import * as React from "react"
import AppUtils from "../../utils/AppUtils";

interface CopyTextProps {
    textToCopy: string;
    copyCallback?: (err: any, data: any) => void
}

const CopyTextCont = (props: CopyTextProps) => {
    const handleClick = () => {
        AppUtils.copyTextToClipboard(props.textToCopy).then((res: any) => {
            props.copyCallback && props.copyCallback(null, res.data)
        }).catch((errRes: any) => {
            props.copyCallback && props.copyCallback(errRes.data, null)
        })
    }
    return (
        <div className={"copy-text"}>
            <div className={"text-cont"}>{props.textToCopy}</div>
            <div className={"copy-btn"} onClick={handleClick}>COPY</div>
        </div>
    )
}
export default CopyTextCont